import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import rowStyles from "~/pages/Q/model/rowStyles.less";

export const getEditorQColumns = (
  t: TFunction,
  options: string[],
  optionChildren: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`editorQ.${option}`),
      dataIndex: option,
      key: option,
      align: (option !== "name" ? "center" : "left") as "left" | "center",
      onCell: (record: any) => {
        let backgroundColor = "";
        if (optionChildren.includes(option)) {
          const quartile = record.GroupIndicatorId?.trim();
          if (quartile === "I") backgroundColor = "#B2D363";
          else if (quartile === "II") backgroundColor = "#FFDE5A";
          else if (quartile === "III") backgroundColor = "#FA9863";
          else if (quartile === "IV") backgroundColor = "#FF747C";
        }
        return {
          style: {
            backgroundColor,
            height: "39px",
          },
        };
      },
    };

    if (optionChildren.includes(option)) {
      return {
        ...baseColumn,
        render: (value: any, record: any) => (
          <div>
            <div className={rowStyles.cont}>{value}</div>
            {record[option + "Period"] && (
              <div className={rowStyles.cont_under}>
                {record[option + "Period"]}
              </div>
            )}
          </div>
        ),
      };
    }

    if (option === "name") {
      return {
        ...baseColumn,
        width: 500,
        render: (value: any) => (
          <div className={rowStyles.kpi_text}>{value}</div>
        ),
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
